<div class="grid-form-control date-control" [class.required]="form?.controls[this.entry.formControlAttributes?.formControlName]?.invalid">
    <form [formGroup]="form">
        <input matInput 
            #entryRef
            [matDatepicker]="picker"
            [formControlName]="entry?.formControlAttributes?.formControlName"
            [name]="entry?.formControlAttributes?.formControlName"
            [id]="entry?.formControlAttributes?.formControlName"
            [min]="dateRange?.min"
            [max]="dateRange?.max"
            (dateChange)="onBlur()" />
            
        <mat-datepicker-toggle 
            [hidden]="entry?.inputAttributes?.hideDatepicker" 
            matSuffix 
            [for]="picker">
        </mat-datepicker-toggle>
        <mat-datepicker #picker startView='multi-year'></mat-datepicker>
    </form>
</div>